export function updateCustomerTypingState(context, customerId, customerTypingState) {
  const activeSessionsStore = context.stores.activeSessions;

  const activeSession = activeSessionsStore.findBy({ customer: { id: customerId } });
  if (!activeSession) {
    return false;
  }

  activeSession.setTypingState(customerTypingState);
  activeSessionsStore.addOrReplace(activeSession);

  return true;
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/concurrent_messaging/lib/update_customer_typing_state.js